import * as CubeTree from '../cubeTree/index';
import CEvent from '../utils/event';
import DragTransfer from './dragTransfer/index';
import Status from './status';
import { get } from './get';

class Drag {
    cubeId: CubeId;
    isInital: boolean = false;
    private dragEvent: any;

    constructor(params) {
        this.cubeId = params.cubeId;
        this.dragEvent = new CEvent();
        this.catchCube();
        this.bindGlobalEvent();
        this.initalDragTransfer();
    }

    private catchCube(): void {
        let cube: CubeNode = CubeTree.findByCubeId(this.cubeId);

        cube.jView.bind('mousedown', (ev: JQuery.MouseDownEvent): void => {
            // 点击了鼠标中键
            if (ev.button === 1 || ev.button === 3) {
                return;
            }

            // 点击了鼠标右键
            if (ev.button === 2) {
                return;
            }

            if (Status.currentDragCube) {
                return;
            }
            Status.currentDragCube = this.cubeId;
            DragTransfer.setMouseDownTarget(ev);
            Status.dragStartX = ev.clientX;
            Status.dragStartY = ev.clientY;
        });
    }

    private bindGlobalEvent(): void {
        if (Status.globalEventIsBind) {
            return;
        }
        Status.globalEventIsBind = true;
        let $win: JQuery<Window> = $(window);

        $win.bind('mousemove', (ev: JQuery.MouseMoveEvent): any => {
            if (!Status.currentDragCube) {
                return;
            }
            let dragCubeNode: DragCubeNode = get(Status.currentDragCube);

            // 判断是否触发了拖拽，起始点和结束点偏差3px就算触发了拖拽
            let move: boolean = this.isMove(
                {
                    left: Status.dragStartX,
                    top: Status.dragStartY
                },
                {
                    left: ev.clientX,
                    top: ev.clientY
                }
            );

            // drag start
            if (Status.dragStatus === 'over') {
                if (!move) {
                    return;
                }
                Status.dragStatus = 'start';
                DragTransfer.create({left: Status.dragStartX, top: Status.dragStartY}, Status.currentDragCube);
                dragCubeNode.fire('dragStart', {ev, transfer: DragTransfer});
                return;
            }

            Status.dragStatus = 'drag';
            DragTransfer.move(ev);
            dragCubeNode.fire('drag', {ev, transfer: DragTransfer});
            return false;
        });

        $win.bind('mouseup', (ev: JQuery.MouseUpEvent): void => {
            DragTransfer.clear();
            if (!Status.currentDragCube) {
                return;
            }
            let dragCubeNode: DragCubeNode = get(Status.currentDragCube);

            if (Status.dragStatus === 'over') {
                Status.currentDragCube = null;
                return;
            }
            Status.dragStatus = 'over';
            dragCubeNode.fire('dragEnd', {ev, transfer: DragTransfer});
            Status.currentDragCube = null;
        });
    }

    private initalDragTransfer(): void {
        if (Status.dragTransferIsInital) {
            return;
        }
        Status.dragTransferIsInital = true;
        DragTransfer.init();
    }

    private fire(dragEventName: DragEventName, params: FreeObjMap): void {
        this.dragEvent.fire(dragEventName, params);
    }

    private isMove(start: MousePoint, end: MousePoint): boolean {
        let disX: number = Math.abs(start.left - end.left);
        let disY: number = Math.abs(start.top - end.top);

        return disX >= 4 || disY >= 4;
    }

    on(dragEventName: DragEventName, callback: (...args) => void): void {
        this.dragEvent.on(dragEventName, callback);
    }
};

export default Drag;
